export interface wizardContentDescription {
    tooltipDescription: string;
    detailDescription: string;
    showToolTip: boolean;
}

export const getWizardContentDescription = (values: any, supportedFields?: any[], limitBeforeToolTip:number = 2): wizardContentDescription => {
    let description: wizardContentDescription = {
        tooltipDescription: '',
        detailDescription: '',
        showToolTip: false
    }
    let currentNumberOfDetails: number = 0;
    if (supportedFields) {

        supportedFields?.map((field) => {
           let elementValue = values.custom[field.displayName];
           if (elementValue === undefined || elementValue === null) {
               elementValue = values.custom[field.systemName];
           }
           if (currentNumberOfDetails < limitBeforeToolTip && elementValue) {
               if (field.options && field.options.length > 0) {
                   description.detailDescription += `${field.options.find(item => item.id?.toString() === elementValue.value?.toString())?.name ?? ''}\n`;
               }
               else {
                   let valueName =  elementValue.name?.length !== 0 ? elementValue.name : elementValue.value
                   if (valueName && valueName.toString().length > 0) {
                       description.detailDescription += valueName + '\n';
                   }
               }
               currentNumberOfDetails++;
           }
           else if (elementValue) {
               // This will be for the tooltip, if we go over a certain number of supported fields
               if (description.tooltipDescription.length === 0) {
                   //description.showToolTip = true;
               }
               if (field.options && field.options.length > 0) {
                   description.tooltipDescription += `${field.options.find(item => item.id === elementValue.value)?.name ?? ''}\n `;
               }
               else {
                   let valueName =  elementValue.name?.length !== 0 ? elementValue.name : elementValue.value
                   if (valueName && valueName.length > 0) {
                       description.tooltipDescription += valueName + '\n';
                   }
               }
               currentNumberOfDetails++;
           }
        });
    }
    if (currentNumberOfDetails > limitBeforeToolTip) {
        // to show there may be more information in a tooltip
        // description.detailDescription += '...';
    }
    return description;
}
